<div class="container-custom-header">
    <div class="container-fluid animate__animated animate__fadeIn">
        <div class="">
            <div class="row align-items-center mt-5">
                <div class="col-12">
                    <div class="d-flex" [ngClass]="!isMobileXL() ? 'justify-content-start' : 'justify-content-center'">
                        <p class="mat-card-header-titulo">
                            {{Etiquetas.Titulo}}</p>
                    </div>
                </div>

                <div class="col-12 order-xxl-3 order-xl-3 order-lg-3 mt-4 mb-4">
                    <mat-divider></mat-divider>
                </div>

            </div>

        </div>

    </div>
</div>
<div class="container-custom-content animate__animated animate__fadeIn  buscador-pedidos">

    <mat-accordion>
        <mat-expansion-panel [expanded]="true" hideToggle #panel="matExpansionPanel">

            <mat-expansion-panel-header>
                <mat-panel-title>
                    Parametros de búsqueda
                </mat-panel-title>
                <mat-icon style="color: white; margin-left: auto;"
                    [style.transform]="panel.expanded ? 'rotate(180deg)' : 'rotate(0deg)'"
                    style="transition: transform 0.3s ease; color: white; margin-left: auto;">
                    expand_more
                </mat-icon>

            </mat-expansion-panel-header>
            <div class="container-fluid mt-4">

                <div class="row align-items-center">



                    <div class="row">

                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" [hidden]="!selectRegiones">
                            <app-selector-regiones #selectorRegion (regionEmitida)="recibirRegionEmitida($event)"
                                [regionRecibida]="regionSeleccionada">
                            </app-selector-regiones>
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.FilterEstado}}</mat-label>
                                <mat-select [(value)]="estadoSeleccionado"
                                    (selectionChange)="selectEstado($event.value)" [compareWith]="compareEstados">
                                    <mat-option [value]="-1">Todos</mat-option>
                                    <mat-option *ngFor="let e of estados" [value]="e">
                                        {{e.descripcion}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                        </div>
                    </div>

                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">

                            <mat-form-field color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.FechaDesde}}</mat-label>
                                <input readonly matInput [matDatepicker]="picker" [(ngModel)]="buscador.fDesde">

                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker [(ngModel)]="buscador.fDesde" #picker></mat-datepicker>

                            </mat-form-field>
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">

                            <mat-form-field color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.FechaHasta}}</mat-label>
                                <input readonly matInput [matDatepicker]="picker2" [(ngModel)]="buscador.fHasta">

                                <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                                <mat-datepicker [(ngModel)]="buscador.fHasta" #picker2></mat-datepicker>

                            </mat-form-field>

                        </div>
                    </div>

                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.FilterProducto}}</mat-label>
                                <input (change)="handleEmptyInputProducto($event)" matInput [matAutocomplete]="auto"
                                    [formControl]="formControlAutocompleteProducto" placeholder="Descripción">
                                <button type="button" matSuffix mat-icon-button
                                    matTooltip="{{Tooltips.LimpiarProducto}}" (click)="limpiarProducto(true)">
                                    <mat-icon color="accent-darker">close</mat-icon>
                                </button>

                                <mat-autocomplete #auto="matAutocomplete"
                                    (optionSelected)='seleccionarProducto($event.option.value)'
                                    [displayWith]="getOptionText">
                                    <mat-option *ngIf="isLoading" class="is-loading">Cargando...</mat-option>
                                    <ng-container *ngIf="!isLoading">
                                        <mat-option *ngFor="let p of filteredOptions" [value]="p">
                                            {{p.displayValue}}
                                        </mat-option>
                                    </ng-container>
                                </mat-autocomplete>

                            </mat-form-field>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.Producto}} Seleccionado</mat-label>
                                <input type="text" *ngIf="productoSeleccionado != null" [disabled]="true" matInput
                                    [value]="productoSeleccionado.displayValue">
                                <input type="text" *ngIf="productoSeleccionado == null" [disabled]="true" matInput
                                    [value]="">
                            </mat-form-field>

                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" [hidden]="!selectTiposOrdenes">
                            <app-selector-tipos-ordenes #selectorTipoOrden
                                (tipoOrdenEmitida)="recibirTipoOrdenEmitida($event)"
                                [tipoOrdenRecibida]="tipoOrdenSeleccionada">
                            </app-selector-tipos-ordenes>
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.NroPedido}}</mat-label>
                                <input numbersOnly [(ngModel)]="buscador.nroPedido" type="text" matInput>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>
        </mat-expansion-panel>

    </mat-accordion>
    <div class="row align-items-center mt-3 mb-3">
        <div class="mat-toolbar-custom">
            <mat-toolbar>
                <mat-toolbar-row>

                    <button (click)="buscar(0)" mat-flat-button color="accent">
                        <mat-icon>search</mat-icon>
                        Buscar</button>

                    <button mat-flat-button color="accent" (click)="cReporteExcel()" [disabled]="loadingReporte">
                        <mat-icon *ngIf="!loadingReporte">download</mat-icon>
                        {{botonReporte}}
                    </button>

                </mat-toolbar-row>

            </mat-toolbar>

        </div>

    </div>



</div>
<div class="container-fluid">
    <div class="row align-items-center justify-content-evenly">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">


            <mat-form-field color="accent-darker" appearance="standard">
                <mat-label>{{Etiquetas.Buscar}}</mat-label>
                <input matInput (keyup)="applyFilter($event)" #input>
            </mat-form-field>
            <div class="mat-table-pedidos">
                <table mat-table matTableResponsive [dataSource]="dataSource" matSort #matSort="matSort"
                    matSortActive="nroPedido" matSortDirection="desc">

                    <ng-container matColumnDef="nroPedido">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{Etiquetas.NroPedido}}
                        </th>
                        <td mat-cell *matCellDef="let cab">
                            {{cab.nroPedido}}
                        </td>
                    </ng-container>

                    <!-- <ng-container matColumnDef="nroCliente">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{Etiquetas.NroCliente}}
                        </th>
                        <td mat-cell *matCellDef="let cab">
                            {{cab.nroCliente}}
                        </td>
                    </ng-container> -->

                    <ng-container matColumnDef="nombreCliente">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{Etiquetas.NombreCliente}}
                        </th>
                        <td mat-cell *matCellDef="let cab">
                            {{cab.nombreCliente}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="estado">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{Etiquetas.Estado}}
                        </th>
                        <td mat-cell *matCellDef="let cab">
                            <div [ngClass]="clasePorEstado(cab.idEstado, cab.idTipoOrden)">
                                {{ cab.estado }}
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="idZonaVendedor">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{Etiquetas.IdZonaVendedor}}
                        </th>
                        <td mat-cell *matCellDef="let cab">
                            {{cab.nombreVendedor}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="nombreDistribuidor">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{Etiquetas.NombreDistribuidor}}
                        </th>
                        <td mat-cell *matCellDef="let cab">
                            {{cab.nombreDistribuidor}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="enviadoDistribuidor">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{Etiquetas.EnviadoDistribuidor}}
                        </th>
                        <td mat-cell *matCellDef="let m">
                            <div>
                                <mat-icon color="accent-darker">{{ m.enviadoDistribuidor ?
                                    'check_box' :
                                    'check_box_outline_blank' }}
                                </mat-icon>
                            </div>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="tipoOrden">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{Etiquetas.TipoOrden}}
                        </th>
                        <td mat-cell *matCellDef="let cab">
                            {{cab.tipoOrden}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="region">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{Etiquetas.Region}}
                        </th>
                        <td mat-cell *matCellDef="let cab">
                            {{cab.region}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="idProducto">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{Etiquetas.IdProducto}}
                        </th>
                        <td mat-cell *matCellDef="let cab">
                            {{cab.idProducto}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="producto">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{Etiquetas.Producto}}
                        </th>
                        <td mat-cell *matCellDef="let cab">
                            {{cab.producto}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="cantidad">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{Etiquetas.Cantidad}}
                        </th>
                        <td mat-cell *matCellDef="let cab">
                            {{cab.cantidad | number }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="moneda">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{Etiquetas.Moneda}}
                        </th>
                        <td mat-cell *matCellDef="let cab">
                            {{cab.moneda}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="total">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{Etiquetas.Total}}
                        </th>
                        <td mat-cell *matCellDef="let cab">
                            {{cab.total | number : '1.2-2'}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="totalLocal">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{Etiquetas.TotalLocal}}
                        </th>
                        <td mat-cell *matCellDef="let cab">
                            {{cab.totalLocal | number : '1.0-0'}}
                        </td>
                    </ng-container>


                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let cab; columns: displayedColumns;">
                    </tr>


                    <tr class="mat-row tr-sin-resultados" *matNoDataRow>
                        <td class="mat-cell" [attr.colspan]="displayedColumns.length">
                            {{Etiquetas.SinRegistros}}
                        </td>
                    </tr>
                </table>

                <mat-paginator #matPaginator="matPaginator" [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons>
                </mat-paginator>
            </div>

        </div>

    </div>

</div>